import React from 'react';
import './stage.css';
import './crm-stage.css';

// AUTO-CRM-32: the page frame every CRM screen shares — the Stage canvas, a
// compact header (eyebrow, title, one-line description, actions) and content.
export default function StagePage({ eyebrow, title, subtitle, actions, children, wide = false, className = '', headerExtra = null }) {
  return (
    <main className={`ws crm-ws${wide ? ' crm-ws--wide' : ''}${className ? ` ${className}` : ''}`}>
      <div className="ws-page">
        {(title || eyebrow) && (
          <header className="crm-page-head ws-rise">
            <div className="ws-grow">
              {eyebrow && <div className="ws-eyebrow">{eyebrow}</div>}
              {title && <h1 className="ws-title">{title}</h1>}
              {subtitle && <p className="ws-muted">{subtitle}</p>}
              {headerExtra}
            </div>
            {actions && <div className="crm-page-actions">{actions}</div>}
          </header>
        )}
        {children}
      </div>
    </main>
  );
}
